/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.37.0
 * @since 1.37.0
 */

import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';

import { RadioButton } from '@components/common';
import { makeSelectTranslationWizardChangeRole } from '@modules/internationalization/intSelectors';
import { IWizardChangeRoleTranslation } from '@modules/internationalization/types/wizards/changeRole';
import {
    makeSelectWizardChangeRoleSelectedAccessLevel,
    makeSelectWizardChangeRoleSubsAccessLevels,
} from '@pages/WizardChangeRole/wizardChangeRoleSelectors';
import { IRootReducer } from '@reducers/rootReducer';

import { TWizardChangeRoleSetParamsPayload } from '../types/wizardChangeRoleActionTypes';
import { wizardChangeRoleSetParamsAction } from '../wizardChangeRoleActions';
import { EWizardChangeRoleRoleConstants, EWizardChangeRoleSteps } from '../wizardChangeRoleConstant';
import { IWizardChangeRoleReducer } from '../wizardChangeRoleReducer';
import { WizardChangeRoleStyled } from './styled/WizardChangeRoleStyled';

const WizardChangeRoleSelectParams = (props: IConnectedProps & IDispatchProps) => {
    const {
        selectedAccessLevel,
        subsAccessLevels,
        translation,

        setParams,
    } = props;

    const stepTranslation = translation[EWizardChangeRoleSteps.StepSelectParams];

    return <WizardChangeRoleStyled>
        <div>
            <div className="wizard-change-role__title">
                {stepTranslation.title}
            </div>
            {
                subsAccessLevels?.map(accessLevel =>
                    <RadioButton checked={ selectedAccessLevel.id === accessLevel.id }
                                 className="wizard-change-role__radio-button"
                                 key={'role_' + accessLevel.id}
                                 label={accessLevel.def}
                                 onChange = {() => {setParams({ selectedAccessLevel: accessLevel })}}
                    />)
            }
            <RadioButton checked={ selectedAccessLevel.id === EWizardChangeRoleRoleConstants.ABSENT }
                         className="wizard-change-role__radio-button"
                         key={'role_off'}
                         label={stepTranslation.levelPut}
                         onChange = {() => {setParams({ selectedAccessLevel: {
                             id: EWizardChangeRoleRoleConstants.ABSENT,
                             def: stepTranslation.levelPut } })}}
            />
        </div>
    </WizardChangeRoleStyled>;
};

export interface IConnectedProps extends Pick<IWizardChangeRoleReducer, 'subsAccessLevels' | 'selectedAccessLevel'> {
    translation: IWizardChangeRoleTranslation;
}

interface IDispatchProps {
    setParams: (payload: TWizardChangeRoleSetParamsPayload) => void;
}

export const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    selectedAccessLevel: makeSelectWizardChangeRoleSelectedAccessLevel(),
    subsAccessLevels: makeSelectWizardChangeRoleSubsAccessLevels(),
    translation: makeSelectTranslationWizardChangeRole(),
});

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
    setParams: (payload: TWizardChangeRoleSetParamsPayload) => dispatch(wizardChangeRoleSetParamsAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WizardChangeRoleSelectParams);
